var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserCrown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224 272C294.75 272 352 214.75 352 144V0L288 32L224 0L160 32L96 0V144C96 214.75 153.25 272 224 272ZM144 128H304V144C304 188.125 268.125 224 224 224S144 188.125 144 144V128ZM272 304H176C78.797 304 0 382.797 0 480C0 497.672 14.326 512 32 512H416C433.674 512 448 497.672 448 480C448 382.797 369.203 304 272 304ZM48.994 464C56.895 400.945 110.84 352 176 352H272C337.16 352 391.105 400.945 399.006 464H48.994Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCrown);
export default __webpack_public_path__ + "static/media/user-crown.6f146518d4a41b4bf7c4455708051100.svg";
export { ForwardRef as ReactComponent };